import { useText } from "components/dictionary/text";
import { VoidFunctionComponent } from "react";
import logo from "images/logo.svg";

export const Logo: VoidFunctionComponent = () => {
  const title = useText("title");
  return <img src={logo} alt={title} />;
};
